/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_PreviewsInputs */

const en_admin_funnel_history_previews = /** @type {(inputs: Admin_Funnel_History_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free previews`)
};

/**
* | output |
* | --- |
* | "Free previews" |
*
* @param {Admin_Funnel_History_PreviewsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_previews = /** @type {((inputs?: Admin_Funnel_History_PreviewsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_PreviewsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_previews(inputs)
});
export { admin_funnel_history_previews as "admin.funnel.history.previews" }